import {
  mdiVectorPolyline,
  mdiVectorSquare,
  mdiFormatColorFill,
} from '@mdi/js';

export const FILL_MODE_NONE = {
  key: 'FILL_MODE_NONE',
  label: 'Open',
  value: {
    closePath: false,
    fillPath: false,
  },
};

export const FILL_MODE_CLOSED = {
  key: 'FILL_MODE_CLOSED',
  label: 'Close',
  value: {
    closePath: true,
    fillPath: false,
  },
};

export const FILL_MODE_FILLED = {
  key: 'FILL_MODE_FILLED',
  label: 'Close & Fill',
  value: {
    closePath: true,
    fillPath: true,
  },
};

export const FILL_MODE_ICONS = {
  [FILL_MODE_NONE.key]: mdiVectorPolyline,
  [FILL_MODE_CLOSED.key]: mdiVectorSquare,
  [FILL_MODE_FILLED.key]: mdiFormatColorFill,
};

export const FILL_MODE_TOOLBAR = [
  FILL_MODE_NONE,
  FILL_MODE_CLOSED,
  FILL_MODE_FILLED,
];
